import React from 'react';
import clsx from 'clsx';
import type {LinkProps} from 'next/link';
import Link from 'next/link';

import {ImageBlock} from '@/modules/foundation/components/image/ImageBlock';
import type {ImageWeb} from '@/modules/foundation/components/image/types';
import {cn} from '@/modules/foundation/shared/tailwind';

type Props = LinkProps & {
	image?: ImageWeb;
	title: string;
	description?: string;
	href: string;
	className?: string;
};

export const NavArticleCard = ({image, title, description, href, className, ...rest}: Props) => {
	return (
		<Link
			href={href}
			className={cn(['block', 'hover:text-link', 'transition-colors'], className)}
			{...rest}
		>
			{image && (
				<ImageBlock
					src={image.image.src}
					width={image.image.width}
					height={image.image.height}
					alt={image.altText ?? ''}
					className={clsx('mb-2', 'rounded-lg')}
				/>
			)}
			<span
				className={clsx(
					'font-semibold',
					'mb-2',
					'block',
					'leading-tight',
					'text-[15px]',
					'min-[1070px]:text-base',
				)}
			>
				{title}
			</span>
			<p
				className={clsx(
					'line-clamp-2',
					'text-primary-2',
					'leading-tight',
					'text-[13px]',
					'min-[1070px]:text-sm',
				)}
			>
				{description}
			</p>
		</Link>
	);
};
